import React, { useRef, useState } from "react";
import { ReactComponent as ImmobiliareIcon } from "assets/icons/immobiliare.svg";
import { ReactComponent as IdealistaIcon } from "assets/icons/idealista.svg";
import { formatCurrency } from "utils/formatNumber";
import TooltipCursor from "components/Tooltip/TooltipCursor";
import useAuth from "hooks/useAuth";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import { listingsMockData } from "mocks/data";
import useSubscription from "hooks/useSubscription";

// source name to logo render function
const renderSourceName = (source_name) => {
  let LogoComponent;
  let altText;

  switch (source_name) {
    case "Idealista":
      LogoComponent = IdealistaIcon;
      altText = "Idealista";
      break;
    case "Immobiliare":
    case "Immobiliare (Sale)":
      LogoComponent = ImmobiliareIcon;
      altText = "Immobiliare";
      break;
    default:
      return (
        <span className="text-sm font-semibold line-clamp-1 overflow-hidden">
          {source_name}
        </span>
      );
  }

  return (
    <LogoComponent
      className="w-full max-w-[93px] lg:max-w-full lg:w-[105px] -mt-[7px]"
      aria-label={altText}
    />
  );
};

const IdentifyPortal = ({
  property,
  height = 143,
  hideHeading = false,
  maxHeight = 143,
}) => {
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  // Filter out listing that has sale_price 0
  const filteredListings =
    user && isPremium
      ? property?.listings?.filter((listing) => listing?.sale_price > 0) || []
      : listingsMockData(); // Use mock listings data if no user is logged in or not premium

  const tdRef = useRef(null); // Create a ref for the td element

  return (
    <>
      <div
        style={{ height: height, maxHeight: maxHeight }}
        className="scroll-container overflow-x-hidden rounded-[9px] border-[1px] border-[#F0EFFB] flex items-start justify-between"
      >
        <div className="pl-[14px] flex-1">
          <div className="flex items-center justify-between pr-[12.5px]">
            <h2 className="text-[12px] font-bold text-black leading-[30px]">
              Portali Identificati
            </h2>

            {(!user || !isPremium) && (
              <>
                <span
                  className="cursor-pointer"
                  data-tooltip-id="identify_portal_tooltip"
                  data-tooltip-content="Identifichiamo se un immobile è stato pubblicato su più piattaforme, anche quando i prezzi differiscono tra un annuncio e l’altro. Con l'iscrizione gratuita potrai visualizzare queste informazioni."
                >
                  <InfoIcon width={15} height={15} />
                </span>
                {/* Info Tooltip  */}
                <ReactTooltip
                  id="identify_portal_tooltip"
                  place="top"
                  positionStrategy="fixed"
                  className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
                />
              </>
            )}
          </div>
          <div className="lg:pr-[24px] ">
            <table className="w-full text-left -mt-[6px]">
              <tbody>
                {filteredListings.length > 0 &&
                  filteredListings.map(
                    (
                      {
                        listing_id,
                        source_name,
                        agency,
                        sale_price,
                        sale_currency,
                        listing_url,
                      },
                      index
                    ) => (
                      <TooltipCursor
                        content={
                          listing_url
                            ? `Se clicchi, verrai reindirizzato all'annuncio di ${source_name}`
                            : "Il link di questo annuncio non è più attivo."
                        }
                        delay={200}
                        key={listing_id}
                        direction="left"
                        visible={(user && isPremium) || index === 0}
                        textStyle={{
                          color: listing_url ? "#8D8D8D" : "orange",
                        }}
                      >
                        <tr
                          onClick={() =>
                            ((listing_url && user && isPremium) ||
                              (index === 0 && listing_url)) &&
                            window.open(listing_url, "_blank")
                          }
                          className={`${
                            filteredListings.length - 1 === index
                              ? "border-none"
                              : "border-b-[1px]"
                          } ${
                            (!user || !isPremium) && index !== 0
                              ? "blur-[12px]"
                              : ""
                          }   w-full border-[#F0F0F0] h-[37px] cursor-ne-resize`}
                        >
                          <td ref={tdRef} className="border-r-[1px] pr-2">
                            {renderSourceName(source_name)}
                          </td>
                          <td className="text-[10px] border-r-[1px] font-semibold text-[#333D43] leading-[1.2] text-center">
                            <span className="line-clamp-1">{agency}</span>
                          </td>
                          <td className="text-[10px] px-3 flex-shrink-0 text-nowrap font-semibold text-[#333D43] leading-[1.2] text-right">
                            {formatCurrency(sale_price, sale_currency)}
                          </td>
                        </tr>
                      </TooltipCursor>
                    )
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default IdentifyPortal;
